import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateClinic = () => {
  return (
    <Create
      title="Създаване на клиника"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateClinic;
